module.exports = __webpack_public_path__ + "./docs/img/icon-prop.e2ae231c73edb7a81b5e4c75f011f362.svg";